module.exports = __webpack_public_path__ + "static/media/np.c28b6869.svg";